import {useEffect,  useState}from 'react'
import { Table,Space,Flex, App } from 'antd';
import Main from '../../cpn/Main';
import { useSearchParams } from 'react-router-dom';
import ModalDel from '../../cpn/ModalDel';
import { useBnsXiangMuBanBenDelMutation, useBnsXiangMuBanBenListQuery } from '../../store/BnsKeJiApi';
import SketchAdd from './SketchAdd';
import SketchEdit from './SketchEdit';

function SketchList() {  
    const {message} = App.useApp()
    const [param] = useSearchParams()
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const bxm_id = param.get('bxm_id')
    const bxm_name = param.get('bxm_name')
    const [list, setList] = useState(); 
    const {data, isSuccess} = useBnsXiangMuBanBenListQuery({bxmbb_bxm_id:bxm_id},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bxmbb_id:key,bxmbb_name,bxm_id,bxmbb_ctime,bxmbb_cname,bxmbb_content,bxm_name,} = item;
                    return item = {key,bxmbb_name,bxm_id,bxmbb_ctime,bxmbb_cname,bxmbb_content,bxm_name,}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bxmbb_ctime;
                    let bTimeString = b.bxmbb_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])  
    const columns = [
        {
            key: 'bxmbb_name',
            title: '界面名称',
            dataIndex: 'bxmbb_name',                  
        }, 
        {
            key: 'bxm_name',
            title: '项目',
            dataIndex: 'bxm_name',            
        },           
        
        {
            key: 'bxmbb_content',
            title: '备注',            
            dataIndex: 'bxmbb_content',           
        },
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bxmbb_ctime + record.bxmbb_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <SketchEdit bxmbb_id={record.key} bxm_id={bxm_id} bxm_name={bxm_name} eu_id={eu_id} eu_name={eu_name}/>
                        <ModalDel onOk={() => {
                                                del({bxmbb_id:record.key}).then((res) => {
                                                    if (res.data.Status === 'success') {
                                                        message.success('删除成功！')                                                                              
                                                    }
                                                    if (res.data.Status === 'fail') {
                                                        message.error('删除失败！'+res.data.Message)
                                                    }
                                                })
                                            }} />  
                       
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsXiangMuBanBenDelMutation()
    
    return (
        <Main selectedKeys={['/SketchList']}>  
            <Flex style={{ marginBottom: 16 }} justify='space-between'>
                <div></div>
                <SketchAdd eu_id={eu_id} eu_name={eu_name} bxm_id={bxm_id} bxm_name={bxm_name}/>
            </Flex>       
            <Table 
                columns={columns} 
                dataSource={list} 
                style={{marginTop:"20px"}}
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}}                 
            />
        </Main>
    )
}

export default SketchList
